/* @flow */

import React from 'react';
import { Card, Icon, Message } from 'semantic-ui-react';
import ResourceImage from 'shared/components/ResourceImage';

type Props = {
  content: CatalogPageContent,
};

const View = ({ content }: Props) => {
  if (content.resource) {
    return (
      <Card centered>
        <ResourceImage resource={content.resource} />
        <Card.Content extra>
          <a
            href={content.resource.url.original}
            target="_blank"
            icon="file pdf outline"
            className="ui labeled fluid icon basic button"
          >
            <Icon name="file pdf outline" />
            Télécharger
          </a>
        </Card.Content>
      </Card>
    );
  }

  return <Message icon="info" header="Aucun PDF associé à cette page" />;
};

export default View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/pdf/View.js